/**
 * ACF extension module.
 *
 * This module will add ACF functionality
 *
 * Libraries:
 * jQuery
 *
 */

/**
* Include the dependencies.
*/
var $ = require('jquery');

module.exports = function () {

    /**
     * ACF hooks
     */
    $(document).ready(function(){

        if( 'undefined' !== typeof acf) {
            /**
             * Adding check for email validation since Safari doesn't support the HTML5 email one
             * We need this to be in document.ready to make the ACF variable available
             */
            acf.add_filter('validation_complete', function( json, $form ){

                /**
                 * Function that validates email addresses
                 * This uses the same HTML5 email regex to be compliant
                 *
                 * @see https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
                 */
                var validate_email = function(email) {
                    var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                    var m,
                        valid = false;

                    if ( email ) {
                        if ( (m = regex.exec(email)) !== null ) {
                            m.forEach(function (match, groupIndex) {
                                valid = true; //Match found, valid email
                            });
                        }
                    }

                    return valid;
                };

                //Check if there is an email field and if it's valid
                var $email_input = $('input[type="email"]', $form);
                // If there is a value in the field and it's not valid
                if ( $email_input.length && ( 0 !== $email_input.val().length ) && !validate_email($email_input.val()) ) {
                    // require array
                    json.errors = json.errors || [];

                    json.errors.push({
                        input: $email_input.attr('name'),
                        message: "Email is not valid"
                    });

                    json.valid = 0;
                } else if( $email_input.length && ( 0 === $email_input.val().length ) && ( 1 === $email_input.parents('.acf-field').data('required') ) ) {
                    //If it's empty and it's required

                    // require array
                    json.errors = json.errors || [];

                    json.errors.push({
                        input: $email_input.attr('name'),
                        message: "Email is required"
                    });

                    json.valid = 0;
                }

                // return
                return json;

            });
        }

        let register_form_pass = document.querySelector('#acf-field_5aafee664c780');
        
        if ( register_form_pass ) {
            register_form_pass.addEventListener('keyup', () => {
                if (register_form_pass.value.length > 72) {
                    alert('Maximum characters for a password is 72.')
                    register_form_pass.value = register_form_pass.value.slice(0, 72);
                }
            })
        }
        
    });

};
